/**
 * Observability API client (E1-8).
 *
 * Typed, read-only (GET-only) wrappers over the observability endpoints, layered
 * on the shared `apiRequest` from `client.ts` (inherits `X-Tenant: mac`,
 * `credentials: "include"`, `ApiError`). These payloads are PII-free by
 * construction (timestamps, counts, statuses only).
 *
 * NOTE: unlike most endpoints these carry NO trailing slash — the backend
 * `observability/urls.py` registers `sync-health` and `counts` verbatim.
 */
import { apiRequest } from "./client";
import type { Counts, SyncHealth } from "./observability.types";

/**
 * `GET /api/observability/sync-health` — every sync lane's freshness plus a
 * top-level ok/degraded roll-up.
 */
export function getSyncHealth(): Promise<SyncHealth> {
  return apiRequest<SyncHealth>("/observability/sync-health");
}

/**
 * `GET /api/observability/counts` — row counts per mirrored entity (counts only,
 * no PII) for an at-a-glance "is the mirror populated?" check.
 */
export function getCounts(): Promise<Counts> {
  return apiRequest<Counts>("/observability/counts");
}
